import { Link } from '@tanstack/react-router';
import { BrandLogo } from '@/components/brand/brand-logo';
import { Button } from '@/components/ui/button';

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-bg-app px-4 text-center">
      <BrandLogo size="md" to="/" />
      <h1 className="mt-8 text-2xl font-semibold text-text-primary">Page not found</h1>
      <p className="mt-2 text-sm text-text-secondary">That link does not exist or has moved.</p>
      <div className="mt-6 flex gap-3">
        <Link to="/">
          <Button variant="secondary">Go home</Button>
        </Link>
        <Link to="/app">
          <Button>Open app</Button>
        </Link>
      </div>
    </div>
  );
}

export function ServerErrorPage({ onRetry }: { onRetry?: () => void }) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-bg-app px-4 text-center">
      <BrandLogo size="md" to="/" />
      <h1 className="mt-8 text-2xl font-semibold text-text-primary">Something went wrong</h1>
      <p className="mt-2 max-w-sm text-sm text-text-secondary">
        We hit an unexpected error. Try again, or contact support if it keeps happening.
      </p>
      <div className="mt-6 flex gap-3">
        {onRetry && (
          <Button variant="secondary" onClick={onRetry}>
            Retry
          </Button>
        )}
        <Link to="/app">
          <Button>Back to Home</Button>
        </Link>
      </div>
    </div>
  );
}

export function SessionExpiredPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-bg-app px-4 text-center">
      <BrandLogo size="md" to="/" />
      <h1 className="mt-8 text-2xl font-semibold text-text-primary">Session expired</h1>
      <p className="mt-2 text-sm text-text-secondary">Sign in again to continue. Your saved work is still there.</p>
      <Link to="/login" className="mt-6 inline-flex">
        <Button>Sign in</Button>
      </Link>
    </div>
  );
}
